export default __webpack_public_path__ + "static/Idea@1200_2x-fd9fb9c65defd3c33d21d22ff06c9478.webp";